import { combineReducers } from 'redux';
import input, * as fromInput from './input';
import { REDUCERS } from '../constants';

const orderTracking = combineReducers({
  [REDUCERS.ORDER]: input(REDUCERS.ORDER),
  [REDUCERS.AUTH_INSTORE]: input(REDUCERS.AUTH_INSTORE),
  [REDUCERS.EMAIL]: input(REDUCERS.EMAIL),
  [REDUCERS.PHONE]: input(REDUCERS.PHONE),
});

export default orderTracking;

export const getInputValue = (state: Object, filter: string) =>
  fromInput.getInputValue(state.orderTracking[filter]);

export const getInputError = (state: Object, filter: string) =>
  fromInput.getInputError(state.orderTracking[filter]);

export const getIsValidInput = (state: Object, filter: string) =>
  fromInput.getIsValidInput(state.orderTracking[filter]);
